export default {
  SUMMARY_INFO: 'SUMMARY_INFO',
  FEES: 'FEES',
  TRANSACTIONS: 'TRANSACTIONS',
  DOCUMENT: 'DOCUMENT',
  COLLATERAL_INFO: 'COLLATERAL_INFO',
  NOTES: 'NOTES',
};
